import React, { useEffect, useRef, useState } from 'react'
import { components, constants, useServices, useTranslation, useWhiteLabelServiceSettings } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import AciHighwayManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import NaCodeMaintenanceApiURLs from 'src/apiUrls/NaCodeMaintenanceApiUrls'
import pathMap from 'src/paths/pathMap'
import CargoFormProperties from '../../cargo/FormProperties'
import AttachCargoDialog from './AttachCargoDialog'
import CargoDialog from './CargoDialog'
import moment from 'moment-timezone'
import axios from 'axios'
import sweetalert from 'sweetalert'
import { Box, Chip, Grid, makeStyles, Select, Tooltip, Typography, useTheme } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Table from '../../../../components/aciacehighway/Table'
import { getStatusMetadata } from '../../../../common/NACommon'
import CargoUploadDialog from './CargoUploadDialog'
import SetResponseMessageDialog from './SetResponseMessageDialog'
import ConfirmDialog from '../../../common/ConfirmDialog'
import ChargeTypeDialog from '../../../common/ChargeTypeDialog'
import { format } from 'date-fns'
import { FileForUserGetUserDetails, GetLoggedInUserPartyName } from 'src/common/FileForUserCommon'
import ErrorMessageDialog from 'src/views/common/ErrorMessageDialog'
import SubmitAllCargoMessageDialog from './SubmitAllCargoMessageDialog'
import ACIHighwayManifestTranslationText from './../../contexts/ACIHighwayManifestTranslationText'
import ACIHighwayCargoTranslationText from './../../contexts/ACIHighwayCargoTranslationText'

const {
  button: { CngButton, CngIconButton },
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL, LIKE }
} = constants

const useStyles = makeStyles((theme) => ({
  select: {
    backgroundColor: theme.name === 'ONE_DARK' ? 'transparent' : theme.palette.common.white,
    fontSize: 14,
    maxWidth: '100%',
    width: 150,
    '& > .MuiOutlinedInput-input': {
      padding: 8
    },
    '& > .MuiSelect-outlined.MuiSelect-outlined': {
      paddingRight: 32
    }
  }
}))

function CargoAttachTable(props) {
  const {
    history,
    manifestId,
    onChangeStep,
    loading,
    onSetLoading,
    showNotification,
    step,
    firstExpectedPortValue,
    expectedArrivalDateTimeValue,
    expectedArrivalTimeZoneValue,
    manifestCarrierCode
  } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()
  const aciHighwayCargoTranslationText = ACIHighwayCargoTranslationText()
  const [lookups, setLookups] = useState(null)
  const [amendmentCodeOptions, setAmendmentCodeOptions] = useState([])
  const [cargoLoadedInList, setCargoLoadedInList] = useState([]);
  const [attachCargoDialog, setAttachCargoDialog] = useState(false)
  const [cargoDialog, setCargoDialog] = useState({ open: false, cargo: null, isView: false })
  const [setResponseMsgDialog, setSetResponseMsgDialog] = useState({ open: false, cargos: [] })
  const [uploadCargoDialog, setUploadCargoDialog] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ open: false, cargo: null })
  const [massDeleteConfirmDialog, setMassDeleteConfirmDialog] = useState({ open: false, idList: null })
  const [submitAllCargoMsgDialog, setSubmitAllCargoMsgDialog] = useState({ open: false })
  const [chargeTypes, setChargeTypes] = useState([])
  const [submitDialog, setSubmitDialog] = useState({ open: false, cargos: [] })
  const [errorMessageDialog, setErrorMessageDialog] = useState({ open: false, errorMessages: [] })
  const [isSuperParty, setSuperParty] = useState(false);
  const [isMassSubmit, setMassSubmit] = useState(false);
  const [ccnHousebillValidation, setCcnHousebillValidation] = useState(false);
  const [ccnHousebillLimit, setCcnHousebillLimit] = useState(1500);

  const tableRef = useRef(null)
  const { createRecord, deleteRecord, fetchRecords, securedSendRequest, updateRecord } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const whiteLabelServiceSettings = useWhiteLabelServiceSettings("aci-highway")
  const theme = useTheme()

  useEffect(() => {
    function onSuccess(response) {
      setCargoLoadedInList(response.data)
    }

    function onError(error) {
      console.log(error);
    }

    function onComplete() { }
    const config = {}

    securedSendRequest.execute('POST', AciHighwayCargoApiUrls.GET_CARGO_LOADED, { manifestId }, onSuccess, onError, onComplete, config, null);
  }, []);

  useEffect(() => {
    Promise.all([
      // Status
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_STATUS' }],
        undefined, 'code'
      ),
      // Countries
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_MANIFEST_COUNTRY' }],
        undefined, 'code'
      ),
      // Country states
      fetchRecords.execute(
        NaCodeMaintenanceApiURLs.GET,
        {
          filters: [{ field: 'indicator', operator: 'EQUAL', value: 'ACI' }],
          customData: { codeMType: 'CountryStateCode' }
        },
        (res) => res.content
      ),
      // Party type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACE_HW_PARTY_TYPE' }],
        undefined, 'code'
      ),
      // First expected port
      fetchRecords.execute(
        NaCodeMaintenanceApiURLs.GET,
        {
          filters: [{ field: 'indicator', operator: 'EQUAL', value: 'ACI' }],
          customData: { codeMType: 'CustomsOffice' }
        },
        (res) => {
          const result = {}

          res.content.forEach((item) => {
            result[item.code] = item.descriptionEn
          })

          return result
        }
      ),
      // Arrival date time zone
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'SCHEDULER_TIME_ZONE' }],
        undefined, 'code'
      ),
      // Amendment codes
      fetchRecords.execute(
        NaCodeMaintenanceApiURLs.GET_NOT_IN_NA,
        {
          customData: { codeMType: constants.CodeMaintenanceType.CODE_MASTER },
          filters: [
            { field: 'active', operator: EQUAL, value: 'true' },
            { field: 'codeType', operator: EQUAL, value: 'ACIHW_CARGO_AMENDMENT_CODE' }
          ]
        },
        (response) => {
          return response.content.map((status) => ({ code: status.code, desc: status.descriptionEn }))
        },
        () => {
          showNotification('error', aciHighwayManifestTranslationText.fetchAmendmentCodeError)
        }
      ),
      // Charge type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_CHARGE_TYPE' }],
        undefined, 'code'
      ),
      // Super party
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_SUPER_PARTY' }],
        undefined, 'code'
      ),
      // CNN Housebill validation
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'CCN_HOUSEBILL_VALIDATION' }],
        undefined, 'code'
      )
    ]).then(
      ([
        status,
        countries,
        countryStates,
        partyType,
        firstExpectedPort,
        arrivalDateAndTimeZone,
        amendmentCodes,
        billingChargeTypes,
        billingSuperParty,
        ccnHousebill
      ]) => {
        const states = Object.keys(countries).reduce((acc, countryCode) => {
          acc[countryCode] = countryStates.filter(
            (state) => state.code === countryCode
          )

          return acc
        }, {})

        if (ccnHousebill) {
          Object.entries(ccnHousebill).forEach((e) => {
            if (e[0] === 'VALIDATION' && e[1].toLowerCase() === 'true') {
              setCcnHousebillValidation(true);
            } else if (e[0] === 'ACI_HIGHWAY') {
              if (/^[+-]?\d+$/.test(e[1])) {
                const keyInt = parseInt(e[1], 10);
                console.log(keyInt)
                setCcnHousebillLimit(keyInt);
              }
            }
          })
        }

        setLookups({
          status,
          countries,
          countryStates: states,
          partyType,
          firstExpectedPort,
          arrivalDateAndTimeZone,
        })

        setAmendmentCodeOptions(amendmentCodes)
        compileChargeTypes(billingChargeTypes)

        Object.keys(billingSuperParty).forEach(e => {
          if (e == GetLoggedInUserPartyName()) {
            setSuperParty(true);
          }
        })
      }
    )
  }, [])

  const submitButton = {
    buttonProps: { color: 'primary', size: 'medium', variant: 'outlined', style: { minWidth: 'auto' } },
    disabled: (rows) => {
      let shouldDisable = false

      rows.forEach((rowData) => {
        if (rowData.status === '1008') {
          shouldDisable = true
        }
      })

      return shouldDisable
    },
    icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
    label: aciHighwayManifestTranslationText.submitButton,
    onClick: (rows) => preSubmitCargos(rows),
    tooltip: (rows) => {
      let includesSentRecords = false

      rows.forEach((rowData) => {
        if (rowData.status === '1008') {
          includesSentRecords = true
        }
      })

      return includesSentRecords ? aciHighwayManifestTranslationText.submitSentRecord : null
    }
  }

  const setResponseMsgButton = {
    buttonProps: { color: 'primary', size: 'medium', variant: 'outlined', style: { minWidth: 'auto' } },
    disabled: (rows) => {
      let shouldDisable = false

      rows.forEach((rowData) => {
        if (rowData.status === '1008') {
          shouldDisable = true
        }
      })

      return shouldDisable
    },
    icon: <FontAwesomeIcon icon={['fal', 'cog']} />,
    label: 'Set response message',
    onClick: (rows) => setSetResponseMsgDialog({ open: true, cargos: rows }),
    tooltip: (rows) => {
      let includesSentRecords = false

      rows.forEach((rowData) => {
        if (rowData.status === '1008') {
          includesSentRecords = true
        }
      })

      return includesSentRecords ? aciHighwayManifestTranslationText.submitSentRecord : null
    }
  }

  const bulkPrintA8AButton = {
    buttonProps: { color: 'primary', size: 'medium', variant: 'outlined', style: { minWidth: 'auto' } },
    icon: <FontAwesomeIcon icon={['fal', 'arrow-to-bottom']} />,
    label: 'Print A8A',
    onClick: (data) => {
      sweetalert(aciHighwayManifestTranslationText.a8aPrintInBg, "", "success");
      return handleBulkPrintA8A(data)
    },
    disabled: (rows) => rows.length > 100,
    tooltip: (rows) => rows.length > 100 ? aciHighwayManifestTranslationText.printLimit100 : aciHighwayManifestTranslationText.bulkPrintingA8A,
  }

  const massDeleteButton = {
    buttonProps: { size: 'medium', color: 'secondary', style: { color: theme.palette.error.main, minWidth: 'auto' } },
    disabled: (rows) => {
      let disable = false;
      rows.forEach(e => {
        if (e.status !== '1005') { disable = true }
      })
      return disable;
    },
    icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
    label: "Mass Delete",
    tooltip: (rows) => {
      let description = null;
      rows.forEach(e => {
        if (e.status !== '1005') { description = aciHighwayManifestTranslationText.onlyDraftCanBeDeleted }
      })
      return description;
    },

    onClick: (rows) => {
      let idList = rows.map(e => e.id)
      setMassDeleteConfirmDialog({ open: true, idList: idList });
    }
  }

  const detachButton = {
    buttonProps: { size: 'medium', color: 'secondary', style: { color: theme.palette.error.main, minWidth: 'auto' } },
    disabled: (rows) => {
      let shouldDisable = false

      rows.forEach((rowData) => {
        if (
          rowData.status === '1000' ||
          rowData.status === '1008' ||
          rowData.status === '1007' ||
          rowData.status === '1004'
        ) {
          shouldDisable = true
        }
      })

      return shouldDisable
    },
    icon: <FontAwesomeIcon icon={['fal', 'minus-circle']} />,
    label: aciHighwayManifestTranslationText.detachButton,
    onClick: handleDetachCargos,
    tooltip: (rows) => {
      let includesSentRecords = false

      rows.forEach((rowData) => {
        if (rowData.status === '1000' || rowData.status === '1008' || rowData.status === '1007' || rowData.status === '1004') {
          includesSentRecords = true
        }
      })

      return includesSentRecords ? aciHighwayManifestTranslationText.detachSentRecord : null
    }
  }

  const [selectedTopBar, setSelectedTopBar] = useState([submitButton, setResponseMsgButton, massDeleteButton, detachButton])

  useEffect(() => {
    if (whiteLabelServiceSettings.length > 0) {
      let bulkPrintA8A = whiteLabelServiceSettings[0].custom.UI_CARGO_ATTACH_TABLE_BULK_PRINT_A8A
      if (bulkPrintA8A == "true") {
        setSelectedTopBar([submitButton, setResponseMsgButton, bulkPrintA8AButton, massDeleteButton, detachButton])
      }
    } else if (isSuperParty) {
      setSelectedTopBar([submitButton, setResponseMsgButton, bulkPrintA8AButton, massDeleteButton, detachButton])

    }
  }, [isSuperParty])

  function compileChargeTypes(billingChargeTypes) {
    var jsonArray = [];
    if (billingChargeTypes) {
      Object.entries(billingChargeTypes).forEach((e) => {
        var jsonObject = { code: e[0], desc: e[1] }
        jsonArray.push(jsonObject)
      })
    }
    setChargeTypes(jsonArray)
  }

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  function getCountryStateLabel(country, state) {
    if (!lookups || !country || !state) return state

    // Check if country code exists in the lookup
    if (Object.keys(lookups.countries).includes(country)) {
      const result = lookups.countryStates[country].find(
        (countryState) => countryState.intlcode === state
      )

      return result ? result.descriptionEn : state
    } else {
      return state
    }
  }

  const columns = [
    {
      field: 'ccn',
      sortKey: 'ccn',
      title: [
        aciHighwayManifestTranslationText.ccn,
        aciHighwayManifestTranslationText.cargoType
      ].join(' / '),
      render: (rowData) => (
        <Box>
          <Typography component='div' variant='inherit'>
            {rowData.ccn}
          </Typography>
          <Typography color='textSecondary' variant='caption'>
            {[(rowData.cargoType === "OSC" ? aciHighwayManifestTranslationText.other : rowData.cargoType), rowData.acquittalNo]
              .filter((value) => value)
              .join(' • ')}
          </Typography>
        </Box>
      )
    },
    {
      field: 'shipperName',
      title: aciHighwayManifestTranslationText.shipperName
    },
    {
      field: 'consigneeName',
      title: aciHighwayManifestTranslationText.consigneeName
    },
    {
      title: aciHighwayManifestTranslationText.cargoLoadedIn,
      render: (rowData) => {
        const selectedRows = tableRef.current.selectedRows
        const isSelected =
          selectedRows.length > 0
            ? selectedRows.map((rowData) => rowData.id).includes(rowData.id)
            : false

        return (
          <CargoLoadedIn
            cargoLoadedInList={cargoLoadedInList}
            isSelected={isSelected}
            isSentStatus={rowData.status === '1008'}
            onUpdateCargo={handleModifyCargo}
            onSubmitCargo={(data) => handleSubmitCargos([data])}
            cargo={rowData}
            aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
          />
        )
      }
    },
    {
      field: 'status',
      sortKey: 'status',
      title: aciHighwayManifestTranslationText.status,
      render: (rowData) => {
        const status = getStatusMetadata(rowData.status)

        if (rowData.status == '1000' && rowData.cargoType == 'REGULAR' && !rowData.entryNo) {
          status.color = "#ffc400"
          status.contrastColor = "#000000"
        }

        return (
          <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>
            <Chip
              label={status.label}
              size='small'
              style={{ color: status.contrastColor, backgroundColor: status.color, fontSize: 12 }}
            />
            {rowData.portMismatch && (
              <Chip key='first' label={aciHighwayManifestTranslationText.portMismatch} size='small'
                style={{ color: '#ffffff', backgroundColor: '#DF2901', fontSize: 12 }}
              />
            )}
          </Box>
        )
      }
    },
    {
      title: `${aciHighwayManifestTranslationText.responseMsg} / ${aciHighwayManifestTranslationText.amendmentCode}`,
      render: (rowData) => {
        const selectedRows = tableRef.current.selectedRows
        const isSelected =
          selectedRows.length > 0
            ? selectedRows.map((rowData) => rowData.id).includes(rowData.id)
            : false

        return (
          <MessageFuncAndAmendmentCode
            amendmentCodeOptions={amendmentCodeOptions}
            isSelected={isSelected}
            isSentStatus={rowData.status === '1008'}
            onUpdateCargo={handleModifyCargo}
            onSubmitCargo={(data) => preSubmitCargos([data])}
            cargo={rowData}
            aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
          />
        )
      }
    },
    {
      field: 'entryNo',
      sortKey: 'entryNo',
      title: aciHighwayManifestTranslationText.entryNo,
      render: (rowData) => (
        <Typography component='div' variant='inherit'>
          {rowData.cargoType !== "CSA" ? rowData.entryNo : ""}
        </Typography>
      )
    },
    {
      field: 'customsBroker',
      sortKey: 'customsBroker',
      title: aciHighwayManifestTranslationText.customsBroker
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: aciHighwayManifestTranslationText.creationdatetime,
      render: (data) => data.createdDate && moment(data.createdDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
  ]

  function handleCreateCargo(data) {
    onSetLoading(true)

    createRecord.execute(
      AciHighwayCargoApiUrls.POST, CargoFormProperties.toServerDataFormat(data),
      (res) => {
        showNotification('success', aciHighwayManifestTranslationText.cargoCreateSuccess)
        setCargoDialog({ open: false, cargo: null, isView: false })
        tableRef.current.performRefresh()
      },
      (error) => {
        const { errorMessages } = error.response.data

        errorMessages.forEach((message) => {
          showNotification('error', message)
        })
      },
      () => onSetLoading(false)
    )
  }

  function handleEditCargo(data) {
    onSetLoading(true)

    updateRecord.execute(
      AciHighwayCargoApiUrls.PUT, CargoFormProperties.toServerDataFormat(data),
      () => {
        tableRef.current.performRefresh()

        setCargoDialog({ open: false, cargo: null, isView: false })
        showNotification('success', aciHighwayManifestTranslationText.cargoUpdated)
      },
      (error) => {
        if (error.response.data.errorMessages) {
          error.response.data.errorMessages.forEach((errorMessage) => {
            showNotification('error', errorMessage)
          })
        }
      },
      () => onSetLoading(false)
    )
  }

  function handleCloneCargo(data) {
    data.cloneFromManifest = 'Y';

    createRecord.execute(
      AciHighwayCargoApiUrls.CLONE, data,
      (res) => {
        res.manifestId = manifestId

        res.arrivalTime = moment(data.arrivalDateAndTime).format('HH:mm');
        res.arrivalDate = moment(data.arrivalDateAndTime).format('YYYY-MM-DD');

        history.push({
          pathname: pathMap.ACI_HW_CARGO_ADD_VIEW,
          state: res
        })
      },
      (error) => {
        console.log(error)
      }
    )
  }

  function handleDetachCargos(rows) {
    const result = { manifestId: Number(manifestId), cargoId: rows.map((cargo) => cargo.id) }

    securedSendRequest.execute(
      'POST', AciHighwayManifestApiUrls.DETACH, result,
      (response) => {
        const data = response.data
        if (data.errorMessages != null && data.errorMessages.length > 0) {
          showNotification('error', data.errorMessages)

        } else if (data.errorMessages === null || data.errorMessages === undefined) {
          if (tableRef.current) {
            tableRef.current.performRefresh()
          }

          showNotification('success', aciHighwayManifestTranslationText.detachSuccessMsg)
        }
      },
      (error) => console.log(error)
    )
  }

  function handleDeleteCargo() {
    if (confirmDialog.cargo) {
      deleteRecord.execute(
        AciHighwayCargoApiUrls.DELETE, confirmDialog.cargo,
        () => {
          showNotification('success', aciHighwayManifestTranslationText.cargoDeleteSucceeded)
          setConfirmDialog({ open: false, cargo: null })
          tableRef.current.performRefresh()
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }

  function handleMassDeleteCargo() {
    if (massDeleteConfirmDialog.idList) {
      setMassDeleteConfirmDialog({ open: false })
      sweetalert(aciHighwayManifestTranslationText.cargoDeleteInProgress, "", "success");
      securedSendRequest.execute('POST',
        AciHighwayCargoApiUrls.MASS_DELETE,
        massDeleteConfirmDialog.idList,
        () => {
          showNotification('success', aciHighwayManifestTranslationText.cargoMassDeleteSucceeded)
          setMassDeleteConfirmDialog({ open: false, idList: null })
          tableRef.current.performRefresh()
        },
        (error) => {
          showNotification('error', aciHighwayManifestTranslationText.cargoMassDeleteError)
          console.log(error)
        }
      )
    }
  }

  function handleModifyCargo(cargos) {
    try {
      if (tableRef.current) {
        tableRef.current.updateData(cargos)
      }
    } catch (error) {
      console.log(error)
    }
  }

  function handlePrintA49(data) {
    const config = { responseType: 'blob' }

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST', AciHighwayCargoApiUrls.PRINTA49, data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ACIHW_CARGO_A49_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined, config, null
    )
  }

  function handlePrintA8A(data) {
    const config = { responseType: 'blob' }

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST', AciHighwayCargoApiUrls.PRINT, data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ACIHW_CARGO_A8A_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined, config, null
    )
  }

  async function handleBulkPrintA8A(data) {
    if (data.length > 0) {
      const config = { responseType: 'blob' }

      let fileForUserDetails = FileForUserGetUserDetails();
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        data.forEach(record => {
          record.fileForUserId = fileForUserDetails.fileForUserId
          record.fileForUserLoginId = fileForUserDetails.fileForUserLoginId
          record.fileForUserPartyId = fileForUserDetails.fileForUserPartyId
        })
      }

      securedSendRequest.execute('POST', AciHighwayCargoApiUrls.BULK_PRINT_A8A, data,
        (response) => {
          let blob = new Blob([response.data])

          let first = 'ACIHW_CARGO_A8A_'
          let curDate = format(new Date(), 'yyyyMMddHHmmss')
          let filename = first + curDate + '.zip'
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          a.href = url
          a.download = filename
          a.click()
        },
        (error) => console.error(error),
        undefined, config, null
      )
    }
  }

  function preSubmitCargos(cargos) {
    if(ccnHousebillValidation && cargos.length > ccnHousebillLimit) { 
        window.alert(aciHighwayManifestTranslationText.ccnHousebillOverLimitMsg.replace('{}', ccnHousebillLimit))
    }
    else if (isSuperParty) {
      setSubmitDialog({ open: true, cargos: cargos })
    } else {
      cargos.forEach(e => {
        e.chargeAs = 'REGULAR'
      })
      handleSubmitCargos(cargos)
    }
  }

  function preSubmitAllCargos(data) {
    if (isSuperParty) {
      setMassSubmit(true)
      setSubmitDialog({ open: true, cargos: data })
    } else {
      data.chargeAs = 'REGULAR'
      handleSubmitAllCargos(data)
    }
  }

  function handleSubmitCargos(cargos) {
    try {
      tableRef.current.setLoading(true)

      let fileForUserDetails = FileForUserGetUserDetails();
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        cargos.forEach(data => {
          data.fileForUserId = fileForUserDetails.fileForUserId;
          data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
          data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
        });
      }

      securedSendRequest.execute(
        'POST', AciHighwayManifestApiUrls.SUBMIT_ALL, cargos,
        (response) => {
          const data = response.data
          var errorMessages = []
          var errorFlag = false
          for (var key in data) {
            var obj = data[key]
            if (obj.errorMessages != null && obj.errorMessages.length > 0) {
              errorMessages.push(obj.errorMessages)
              errorFlag = true
            }
          }
          if (errorFlag) {
            setErrorMessageDialog({ open: true, errorMessages })
          } else {
            showNotification('success', aciHighwayCargoTranslationText.submitSuccessMsg)
            tableRef.current.performRefresh()
          }
        },
        (error) => {
          if (error.response?.data) {
            var errorMessages = []
            const data = error.response.data
            const errorMessage = data.description

            if (errorMessage != '') {
              errorMessages.push(errorMessage)
              setErrorMessageDialog({ open: true, errorMessages })
            }
          }
          console.log(error)
        },
        () => tableRef.current.setLoading(false)
      )
    } catch (error) {
      console.log(error)
    }
  }

  function handleSubmitAllCargos(data) {
    try {
      tableRef.current.setLoading(true)

      const formData = new FormData()
      formData.append('manifestId', Number(data.manifestId))
      formData.append('status', data.status)
      formData.append('chargeAs', data.chargeAs)

      let fileForUserDetails = FileForUserGetUserDetails();
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails));
      } else {
        formData.append("fileForUserDetails", "{}");
      }

      securedSendRequest.execute(
        'POST', AciHighwayManifestApiUrls.SUBMIT_ALL, formData,
        (response) => {
          const data = response.data
          var errorMessages = []
          var errorFlag = false
          for (var key in data) {
            var obj = data[key]
            if (obj.errorMessages != null && obj.errorMessages.length > 0) {
              errorMessages.push(obj.errorMessages)
              errorFlag = true
            }
          }
          if (errorFlag) {
            setErrorMessageDialog({ open: true, errorMessages })
          } else {
            showNotification('success', aciHighwayCargoTranslationText.submitSuccessMsg)
            tableRef.current.performRefresh()
          }
        },
        (error) => console.log(error),
        () => tableRef.current.setLoading(false)
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'secondary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
              onClick: () => setSubmitAllCargoMsgDialog({ open: true })
            },
            label: aciHighwayManifestTranslationText.submitAllCargo
          },          
          {
            buttonProps: {
              color: 'secondary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'upload']} />,
              onClick: () => setUploadCargoDialog({ open: true, tableRef: tableRef })
            },
            label: aciHighwayManifestTranslationText.uploadNewCargo
          },
          {
            buttonProps: {
              color: 'secondary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () =>
                setCargoDialog({ open: true, cargo: null, isView: false })
            },
            label: aciHighwayManifestTranslationText.createNewCargo
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'link']} />,
              onClick: () => setAttachCargoDialog(true)
            },
            label: aciHighwayManifestTranslationText.attachCargo
          }
        ]}
        checkboxSelection
        columns={columns}
        compact
        customRowActions={[
          {
            iconButtonProps: { icon: ['fal', 'minus-circle'], style: { color: theme.palette.error.main } },
            onClick: (rowData) => handleDetachCargos([rowData]),
            tooltip: () => aciHighwayManifestTranslationText.detachButton
          }
        ]}
        fetch={{ url: AciHighwayCargoApiUrls.CUSTOM_SEARCH }}
        fetchFilters={[{ field: 'manifestId', operator: EQUAL, value: manifestId }]}
        onPostFetch={(data) => {
          data.forEach((cargo) => {
            if (cargo.cargoLoadedInTrailer) {
              cargo.cargoLoadedIn = ("L" + cargo.cargoLoadedInTrailer)
            } else if (cargo.cargoLoadedInTruck) {
              cargo.cargoLoadedIn = ("V" + cargo.cargoLoadedInTruck)
            }
          })
          return data;
        }}
        onRowClick={(rowData) =>
          setCargoDialog({ open: true, cargo: CargoFormProperties.toClientDataFormat(rowData), isView: true })
        }
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aciHighwayManifestTranslationText.editButton,
            onClick: (rowData) => setCargoDialog({ open: true, cargo: rowData, isView: false }),
            tooltip: (rowData) => rowData.status === '1008' ? aciHighwayManifestTranslationText.editSentRecord : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: aciHighwayManifestTranslationText.cloneButton,
            onClick: handleCloneCargo
          },
          {
            disabled: (rowData) => rowData.status !== '1005',
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aciHighwayManifestTranslationText.deleteButton,
            onClick: (rowData) => setConfirmDialog({ open: true, cargo: rowData }),
            tooltip: (rowData) => rowData.status !== '1005' ? aciHighwayManifestTranslationText.onlyDraftCanBeDeleted : null
          },
          {
            label: aciHighwayManifestTranslationText.printA8A,
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA8A
          },
          {
            label: aciHighwayManifestTranslationText.printA49,
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA49
          }
        ]}
        selectActions={selectedTopBar}
        search={{ field: 'ccn', operator: LIKE }}
        showNotification={showNotification}
        tableRef={tableRef}
        helperText={aciHighwayManifestTranslationText.attachCargoSectionHelper}
      />
      <Box marginTop={2}>
        <Grid container justify='space-between' spacing={3}>
          <Grid item xs={12} md='auto'>
            <CngButton
              color='secondary'
              onClick={() => history.push(pathMap.ACIHWY_MANIFEST_LIST_VIEW)}
              size='medium'
            >
              {aciHighwayManifestTranslationText.discardButton}
            </CngButton>
          </Grid>
          <Grid item xs={12} md='auto'>
            <Grid container spacing={2}>
              <Grid item xs='auto'>
                <CngButton
                  color='secondary'
                  onClick={() => onChangeStep(step - 1)}
                  size='medium'
                >
                  {aciHighwayManifestTranslationText.backButton}
                </CngButton>
              </Grid>
              <Grid item xs='auto'>
                <CngButton color='primary' onClick={() => onChangeStep(step + 1)} size='medium'>
                  {aciHighwayManifestTranslationText.addSNButton}
                </CngButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <AttachCargoDialog
        columns={columns}
        manifestId={manifestId}
        open={attachCargoDialog}
        onAttachCargo={() => {
          if (tableRef.current) {
            tableRef.current.performRefresh()
          }
        }}
        onClose={() => setAttachCargoDialog(false)}
        showNotification={showNotification}
      />
      <CargoDialog
        getCountryStateLabel={getCountryStateLabel}
        getLookupValue={getLookupValue}
        isView={cargoDialog.isView}
        manifestId={manifestId}
        firstExpectedPortValue={firstExpectedPortValue}
        expectedArrivalDateTimeValue={expectedArrivalDateTimeValue}
        expectedArrivalTimeZoneValue={expectedArrivalTimeZoneValue}
        loading={loading}
        onClose={() =>
          setCargoDialog({ open: false, cargo: null, isView: false })
        }
        onCreateCargo={handleCreateCargo}
        onEditCargo={handleEditCargo}
        open={cargoDialog.open}
        cargo={cargoDialog.cargo}
        showNotification={showNotification}
        manifestCarrierCode={manifestCarrierCode}
      />
      <SetResponseMessageDialog
        amendmentCodeOptions={amendmentCodeOptions}
        onClose={() => setSetResponseMsgDialog({ open: false, cargos: [] })}
        onSaveCargo={(cargos) => {
          handleModifyCargo(cargos)
          setSetResponseMsgDialog({ open: false, cargos: [] })
        }}
        onSubmitCargo={preSubmitCargos}
        open={setResponseMsgDialog.open}
        cargos={setResponseMsgDialog.cargos}
        aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
      />
      <CargoUploadDialog
        manifestId={manifestId}
        open={uploadCargoDialog}
        onClose={() => setUploadCargoDialog(false)}
        showNotification={showNotification}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, cargo: null })}
        confirmDialog={handleDeleteCargo}
        content={aciHighwayManifestTranslationText.deleteItemConfirmMsg}
        okMsg={aciHighwayManifestTranslationText.okDeleteButton}
        cancelMsg={aciHighwayManifestTranslationText.cancelDeleteButton}
        title={aciHighwayManifestTranslationText.deleteButton}
      />
      <ConfirmDialog
        isConfirmDialogOpen={massDeleteConfirmDialog.open}
        closeDialog={() => setMassDeleteConfirmDialog({ open: false, idList: null })}
        confirmDialog={handleMassDeleteCargo}
        content={aciHighwayManifestTranslationText.deleteItemConfirmMsg}
        okMsg={aciHighwayManifestTranslationText.okDeleteButton}
        cancelMsg={aciHighwayManifestTranslationText.cancelDeleteButton}
        title={aciHighwayManifestTranslationText.deleteButton}
      />
      <ChargeTypeDialog
        chargeTypes={chargeTypes}
        onClose={() => setSubmitDialog({ open: false, cargos: [] })}
        onSubmit={isMassSubmit ? handleSubmitAllCargos : handleSubmitCargos}
        open={submitDialog.open}
        items={submitDialog.cargos}
      />
      <ErrorMessageDialog
        errorMessages={errorMessageDialog.errorMessages}
        open={errorMessageDialog.open}
        onClose={() => setErrorMessageDialog({ open: false })} />
      <SubmitAllCargoMessageDialog
        manifestId={manifestId}
        onClose={() => setSubmitAllCargoMsgDialog({ open: false })}
        onSubmitCargo={preSubmitAllCargos}
        open={submitAllCargoMsgDialog.open}
        aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
      />        
    </>
  )
}

export default CargoAttachTable

function MessageFuncAndAmendmentCode(props) {
  const {
    amendmentCodeOptions,
    isSelected,
    isSentStatus,
    onSubmitCargo,
    cargo,
    onUpdateCargo,
    aciHighwayManifestTranslationText
  } = props

  const theme = useTheme()
  const classes = useStyles()

  function handleSubmitButtonClick(event) {
    event.stopPropagation()
    onSubmitCargo(cargo)
  }

  return (
    <Grid alignItems='center' container spacing={1} wrap='nowrap'>
      <Grid item xs='auto'>
        <Select
          className={classes.select}
          disabled={isSentStatus || !isSelected}
          native
          onChange={(event) =>
            onUpdateCargo({ ...cargo, messageFunction: event.target.value })
          }
          onClick={(event) => event.stopPropagation()}
          size='small'
          value={cargo.messageFunction || ''}
          variant='outlined'
        >
          <option value='' disabled>
            {aciHighwayManifestTranslationText.messageFunction}
          </option>
          <option value='00'>{aciHighwayManifestTranslationText.msgFunctionAdd}</option>
          <option value='04'>{aciHighwayManifestTranslationText.msgFunctionModify}</option>
          <option value='03'>{aciHighwayManifestTranslationText.msgFunctionDelete}</option>
          <option value='CO'>
            {aciHighwayManifestTranslationText.msgFunctionCorrected}
          </option>
        </Select>
      </Grid>
      {cargo.messageFunction === 'CO' && (
        <Grid item xs='auto'>
          <Select
            className={classes.select}
            disabled={isSentStatus || !isSelected}
            native
            onChange={(event) =>
              onUpdateCargo({ ...cargo, amendmentCode: event.target.value })
            }
            onClick={(event) => event.stopPropagation()}
            size='small'
            value={cargo.amendmentCode || ''}
            variant='outlined'
          >
            <option value='' disabled>
              {aciHighwayManifestTranslationText.amendmentCode}
            </option>
            {amendmentCodeOptions.map((option) => (
              <option key={option.value} value={option.code}>
                {option.desc}
              </option>
            ))}
          </Select>
        </Grid>
      )}
      <Grid item xs='auto'>
        <Tooltip
          arrow
          placement='top'
          title={
            isSentStatus
              ? aciHighwayManifestTranslationText.submitSentRecord
              : aciHighwayManifestTranslationText.submitButton
          }
        >
          <span>
            <CngIconButton
              disabled={isSentStatus || !isSelected || !cargo.messageFunction}
              size='small'
              icon={['fal', 'arrow-alt-right']}
              onClick={handleSubmitButtonClick}
              type='outlined'
            />
          </span>
        </Tooltip>
      </Grid>
    </Grid>
  )
}

function CargoLoadedIn(props) {
  const {
    cargoLoadedInList,
    isSelected,
    isSentStatus,
    onSubmitCargo,
    cargo,
    onUpdateCargo,
    aciHighwayManifestTranslationText
  } = props

  const theme = useTheme()
  const classes = useStyles()

  function handleSubmitButtonClick(event) {
    event.stopPropagation()
    onSubmitCargo(cargo)
  }

  return (
    <Grid alignItems='center' container spacing={1} wrap='nowrap'>
      <Grid item xs='auto'>
        <Select
          className={classes.select}
          disabled={isSentStatus || !isSelected}
          native
          onChange={(event) =>
            onUpdateCargo({ ...cargo, cargoLoadedIn: event.target.value })
          }
          onClick={(event) => event.stopPropagation()}
          size='small'
          value={cargo.cargoLoadedIn}
          variant='outlined'
        >
          <option value='' disabled>
            {aciHighwayManifestTranslationText.cargoLoadedIn}
          </option>
          {cargoLoadedInList.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </Select>
      </Grid>
    </Grid>
  )
}
